var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_1359_2948)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 18.333H13.75V24.1663H15.4167V18.333ZM20.4167 18.333H18.75V24.1663H20.4167V18.333ZM27.5 25.833H11.6667V27.4997H27.5V25.833ZM25.4167 18.333H23.75V24.1663H25.4167V18.333ZM19.5833 10.833L11.6667 14.9997V16.6663H27.5V14.9997L19.5833 10.833ZM15.2417 14.9997L19.5833 12.7163L23.925 14.9997H15.2417Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1359_2948",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF79D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2271E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/University.2b928ae9fe53dd02a884ea71aeef467d.svg";
export { ForwardRef as ReactComponent };